import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "appDetailView" }

import { getAppVoByIdUsingGet } from "@/api/appController";
//@ts-ignore
import { ref, watchEffect, computed } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import dayjs from "dayjs";
import { useLoginUserStore } from "@/store/useStore";
import ShareModal from "@/components/ShareModal.vue";

interface Props {
  id: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDetailView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

const data = ref<API.AppVO>({});

const prop = __props;
// 加载数据
const loadData = async () => {
  if (!prop.id) {
    message.error("应用不存在");
    return;
  }
  const res = await getAppVoByIdUsingGet({ id: prop.id as any });
  if (res.data.code === 0) {
    data.value = res.data.data as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量：触发加载
 */
watchEffect(() => {
  loadData();
});

//获取登录用户
const loginUserStore = useLoginUserStore();
let loginUserId = loginUserStore.loginUser?.id;

//是不是本人创建的应用
const isMy = computed(() => {
  return loginUserId && loginUserId === data.value.userId;
});

// 分享弹窗的引用
const shareModalRef = ref();

// 分享链接
const shareLink = `${window.location.protocol}//${window.location.host}/app/detail/${prop.id}`;

// 分享
const doShare = (e: Event) => {
  if (shareModalRef.value) {
    shareModalRef.value.openModal();
  }
  // 阻止冒泡，防止跳转到详情页
  e.stopPropagation();
};

return (_ctx: any,_cache: any) => {
  const _component_P = _resolveComponent("P")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h1", { style: {"text-align":"center"} }, "应用详情", -1)),
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              class: "content-wrapper"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString(data.value.appName), 1),
                _createElementVNode("p", null, "应用描述：" + _toDisplayString(data.value.appDesc), 1),
                _createElementVNode("p", null, "应用类型：" + _toDisplayString(_unref(APP_TYPE_MAP)[data.value.appType!]), 1),
                _createVNode(_component_P, null, {
                  default: _withCtx(() => [
                    _createTextVNode("应用策略：" + _toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[data.value.scoringStrategy!]), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, [
                  _cache[0] || (_cache[0] = _createTextVNode(" 作者： ", -1)),
                  _createVNode(_component_a_avatar, {
                    size: 24,
                    style: { marginRight: '8px' },
                    "image-url": data.value.user?.userAvatar
                  }, null, 8, ["image-url"]),
                  _createVNode(_component_a_typography_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.user?.userName || "匿名"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, " 创建时间： " + _toDisplayString(_unref(dayjs)(data.value.createTime).format("YYYY-MM-DD HH:mm:ss")), 1),
                _createVNode(_component_a_space, { size: "medium" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      href: `/answer/do/${__props.id}`
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("开始答题 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_a_button, { onClick: doShare }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("分享应用", -1)
                      ]))]),
                      _: 1
                    }),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          href: `/add/question/${__props.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("设置题目 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          href: `/add/scoring_result/${__props.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("设置评分 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          href: `/add/app/${__props.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("修改应用", -1)
                          ]))]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { flex: "320px" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_image, {
                    src: data.value?.appIcon,
                    alt: data.value?.appName,
                    width: "100%"
                  }, null, 8, ["src", "alt"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ShareModal, {
      link: shareLink,
      title: "应用分享",
      ref_key: "shareModalRef",
      ref: shareModalRef
    }, null, 512)
  ]))
}
}

})